/*
  ErrorConfig.js
*/

export const errorConfig = {
  'hardware ID in use' : 'This device is already in use and cannot be added. Please delete the existing device and try again',
}
